var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ml-3 mr-2" },
    [
      _c(
        "v-menu",
        {
          staticClass: "title-selector",
          attrs: {
            transition: "slide-y-transition",
            "offset-y": "",
            bottom: "",
            "full-width": "",
            "close-on-content-click": _vm.closeOnContentClick
          },
          model: {
            value: _vm.vModel,
            callback: function($$v) {
              _vm.vModel = $$v
            },
            expression: "vModel"
          }
        },
        [
          _c(
            "v-btn",
            {
              staticClass: "title-selector--label",
              attrs: { slot: "activator", flat: "", block: "" },
              slot: "activator"
            },
            [
              _c(
                "strong",
                {
                  staticClass: "object-title",
                  staticStyle: { display: "inline-block" }
                },
                [_vm._v(_vm._s(_vm.title))]
              ),
              _vm._v(" "),
              _vm._t("default"),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-icon",
                { staticClass: "mr-3", attrs: { color: _vm.color } },
                [_vm._v("keyboard_arrow_down")]
              )
            ],
            2
          ),
          _vm._v(" "),
          _vm.allowMenu
            ? _c(
                "div",
                [
                  _c(
                    "v-list",
                    [
                      _c("v-list-tile", { staticStyle: { padding: "0" } }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.dtSearch,
                              expression: "dtSearch"
                            }
                          ],
                          staticClass: "title-selector--input",
                          attrs: {
                            type: "text",
                            placeholder: "Tapez quelque chose à filtrer"
                          },
                          domProps: { value: _vm.dtSearch },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.dtSearch = $event.target.value
                              },
                              _vm.handleChange
                            ]
                          }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        background: "white",
                        "max-height": "300px"
                      }
                    },
                    [
                      _c(
                        "v-list",
                        [
                          _vm._l(_vm.coSource, function(menu, i) {
                            return _c(
                              "v-list-tile",
                              {
                                key: i,
                                staticClass: "title-selector__list-item",
                                on: {
                                  click: function($event) {
                                    _vm.handleItemClicked({
                                      data: menu,
                                      index: i
                                    })
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-list-tile-title",
                                  {
                                    staticClass: "title-selector--text-inline"
                                  },
                                  [
                                    _vm.hasSlot
                                      ? _vm._t("default", null, { item: menu })
                                      : [_vm._v(_vm._s(menu.text))]
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _vm.loadMoreVisible
                            ? _c(
                                "v-list-tile",
                                {
                                  staticStyle: { padding: "0" },
                                  on: { click: _vm.handleLoadMoreClicked }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        "xs-12": "",
                                        "text-xs-center": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "title-selector--button",
                                          attrs: { flat: "", block: "" }
                                        },
                                        [
                                          _c(
                                            "i",
                                            { attrs: { color: "secondary" } },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("BTN_SEEMORE"))
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "title-selector--line",
        style: { "background-color": _vm.color }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2920eceb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2920eceb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/sub-navigation-title/template.html
// module id = null
// module chunks = 